import { forwardRef } from 'react'

import { IconProps } from '../../../types/types'

export const ServiceSvg = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	const { size = 24, ...rest } = props

	return (
		<svg
			ref={ref}
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...rest}>
			<path
				d="M20 5.36009V10.3559C20 17.9732 12.4167 20.9297 12.4167 20.9297L12 21.1L11.5833 20.9297C11.5833 20.9297 4 17.9732 4 10.3559V5.36009C4 4.99937 4.14048 4.65343 4.39052 4.39836C4.64057 4.14329 4.97971 4 5.33333 4H18.6667C19.0203 4 19.3594 4.14329 19.6095 4.39836C19.8595 4.65343 20 4.99937 20 5.36009Z"
				fill="#4A4A4A"
			/>
			<path
				d="M19.9993 10.3559V5.36009C19.9993 4.99937 19.8589 4.65343 19.6088 4.39836C19.3588 4.14329 19.0196 4 18.666 4H12.416V20.9297C13.681 20.5004 19.9993 17.9732 19.9993 10.3559Z"
				fill="url(#paint0_linear_13382_131595)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.0624 12.9678L15.5091 8.15878C15.8958 7.74054 16.5494 7.71801 16.964 8.10861C17.3732 8.49411 17.3954 9.13732 17.0137 9.55009L11.6278 15.3749C11.3229 15.7046 10.8018 15.7045 10.4969 15.3749L8.05835 12.7376C7.67667 12.3248 7.69885 11.6816 8.10805 11.2961C8.52267 10.9055 9.17628 10.928 9.56301 11.3463L11.0624 12.9678Z"
				fill="white"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_13382_131595"
					x1="13.4111"
					y1="-0.275004"
					x2="13.4111"
					y2="22.525"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#E4EDFC" />
					<stop offset="1" stopColor="#568DFE" />
				</linearGradient>
			</defs>
		</svg>
	)
})
